module.exports = __webpack_public_path__ + "img/artnhealing_option_03.ea216afc.jpg";